module.exports = __webpack_public_path__ + "img/wx-qrcode.8377e278.png";